import { render } from "./UserRegistrationByCode.vue?vue&type=template&id=01d383fc&scoped=true&ts=true"
import script from "./UserRegistrationByCode.vue?vue&type=script&lang=ts"
export * from "./UserRegistrationByCode.vue?vue&type=script&lang=ts"

import "./UserRegistrationByCode.vue?vue&type=style&index=0&id=01d383fc&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\eFJ\\eFjApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01d383fc"]])

export default __exports__